module.exports = __webpack_public_path__ + "img/caracteristicas-flatpanel.f7db0ac0.png";